<template>
  <div class="about">
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li>为了信息化发展终将创造的所有美好</li>
        </ul>
        <h1>关于安信软件</h1>
      </div>
    </div>
    <about></about>
    <culture></culture>
    <!-- <history></history> -->
    <copyright></copyright>
  </div>
</template>

<script>
import About from "../compents/About";
import Culture from "../compents/Culture";
import History from "../compents/History";
import Copyright from "../compents/Copyright";
export default {
  components: {
    About,
    Culture,
    History,
    Copyright
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.other-banner {
  background: url("@/../../assets/img/banner/banner2.jpg");
  .crumb{
    li:last-child{
      color: #ffffff !important;
    }
  }
}
</style>
